import { Navigate, useRouteError } from 'react-router-dom';

import { LANDING } from 'constants/__generated__/routes';
import { formatError } from 'lib/error';
import { HandledError } from 'routing/HandledError';

const UnhandledError = ({ baseError }: { baseError: any }) => {
  return (
    <HandledError code={500} message={`Unexpected ${baseError?.toString()}`} />
  );
};

export const RouteErrorBoundary = () => {
  const baseError: any = useRouteError();
  const { error, handleError = false } = formatError(baseError) || {};

  if (error && handleError) {
    if (error.code === 401) {
      return (
        <Navigate
          replace
          to={{
            pathname: LANDING,
          }}
        />
      );
    }

    return (
      <HandledError
        code={error.code}
        message={error.message || ''}
        urls={error.urls}
      />
    );
  }

  return <UnhandledError baseError={baseError} />;
};
